module.exports = __webpack_public_path__ + "static/media/12-09-react-router-netlify-page-not-found.c1aa8e98.md";